import getPlatformFromInappId from "@utils/priceAndCurrencyMethods/getPlatformFromInappId";

function createSelectList(options, id) {
    const platform = getPlatformFromInappId(id);
    const arr = options?.map(item => ({
        id: item.tier,
        value: item[platform]?.USD || item.ios.USD,
        label: `${item.tier} - ${item[platform]?.USD || item.ios.USD}`
    }));
    return arr.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))
}

export default createSelectList;